import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { DocumentService } from 'src/app/core/services/document.service';
import { Message } from 'src/app/core/class/message';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-sign-wait-progress-usb-token',
  templateUrl: './sign-wait-progress-usb-token.component.html',
  styleUrls: ['./sign-wait-progress-usb-token.component.scss']
})
export class SignWaitProgressUsbTokenComponent implements OnInit, OnDestroy {

  /**
 * Finish progress value.
 */
  public static FINISH_PROGRESS_VALUE = 100;

  /**
   * stop sign action.
   */
  public static STOP_ACTION = 'stop';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * finish popup action.
   */
  public static FINISH_ACTION = 'finish';

  /**
   * selection action close.
   */
  private selectedActionClose = SignWaitProgressUsbTokenComponent.CLOSE_ACTION;

  /**
   * Displayed columns.
   */
  public displayedColumns: string[] = [
    'check',
    'STT',
    'contractName',
    'numberFile',
    'allName',

  ];

  /**
   * The data source of page.
   */
  public dataSource: any
  public noOfFiles: any = 0;
  public data1: any;
  public data2: any;

  /**
   * Slot request timer.
   */
  // private slotRequestTimer: any;

  /**
   * Percent of processing.
   */
  public processedPercent = 0;

  /**
   * length of document.
   */
  public documentCount = 0;

  /**
   * Disable stop sign button.
   */
  public isDisabledStopSignButton = false;

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  isFinished = false;

  @BlockUI() blockUI: NgBlockUI;

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // public dialogRef: MatDialogRef<SignWaitProgressComponent>,
    // private signOption: string,
    private documentService: DocumentService,
    private dialog: MatDialog,
    public message: Message,
    @Inject(MAT_DIALOG_DATA) public data: {
      isFinished: boolean
    }
  ) {
    this.isFinished = data && data.isFinished;
  }

  /**
   * initialize data.
   */
  ngOnInit() {
    this.dataSource = [];
    this.documentCount = 0;
    let isFirstRun = true;

    this.documentService.signWaitUpdateAction.subscribe((result) => {
      console.log(result);
      if (!result || !result.res || !result.res.data) {
        this.isDisabledStopSignButton = true;
        return;
      }

      this.isDisabledStopSignButton = this.selectedActionClose === SignWaitProgressUsbTokenComponent.STOP_ACTION;
      const rs = result.res;
      const signStatus = result.signStatus;
      const percent = result.percent;

      if (this.dataSource.length === 0 || isFirstRun) {
        isFirstRun = true;
        // const ds = [];
        if (!rs.data.info || !rs.data.contracts) {
          return;
        }

        // initialize list.
        const contracts = JSON.parse(rs.data.contracts);
        // set value of progress.
        if (this.documentCount === 0) {
          this.documentCount = contracts.length;
        }

        const mapContract = {};
        // update status for each document.

        rs.data.info.details.forEach((item) => {
          mapContract[item.contractId] = item;
        });

        contracts.forEach(ct => {
          // let selectedItem = rs.data.info.details.filter((item) => {
          //   if (item.contractId === ct.id) {
          //     return item;
          //   }
          // });

          let selectedItem = mapContract[ct.id];
          if (selectedItem) {
            ct.status = selectedItem.status;
            ct.description = selectedItem.description || this.message.getMessage("messages.sign_fail");
          }
          // ds.push(ct);
        });
        const ds = [...contracts];
        this.data1   = [...contracts];
        this.data2 = JSON.parse(localStorage.getItem('dataPopupSignProcess'));
        this.noOfFiles = this.data2.reduce(function (s, a) {
          return s + a.contractAttachments.length;
        }, 0);
        this.data1.forEach(ele => {
          this.data2.forEach(ala =>{
            if(ele.id === ala.id ) {
              ele.nameConfirm = ala.signerName ? ala.signerName : (ala.signerConfirms ? ala.signerConfirms : '') ;
              ele.fileNumber = ala.contractAttachments;
            }
          })
        })
        this.dataSource = this.data1;
      } else {
         this.data2 = JSON.parse(localStorage.getItem('dataPopupSignProcess'));
        this.noOfFiles = this.data2.reduce(function (s, a) {
          return s + a.contractAttachments.length;
        }, 0);
        this.dataSource.forEach(ele => {
          this.data2.forEach(ala =>{
            if(ele.id === ala.id ) {
              ele.nameConfirm = ala.signerName ? ala.signerName : (ala.signerConfirms ? ala.signerConfirms : '') ;
              ele.fileNumber = ala.contractAttachments;
            }
          })
        })
        // Only update status of datasource, don't update element.
        this.dataSource.forEach(ct => {
          rs.data.info.details.filter((item) => {
            if (item.contractId === ct.id) {
              ct.status = item.status;
              return;
            }
          });
        });
      }

      // update progress of signed document.
      this.processedPercent = percent;

      if (signStatus === DocumentService.SLOT_SIGN_FINISH
        || signStatus === DocumentService.SLOT_SIGN_NO_ACTION) {
        this.isDisabledStopSignButton = true;

        if (signStatus === DocumentService.SLOT_SIGN_FINISH) {
          this.processedPercent = SignWaitProgressUsbTokenComponent.FINISH_PROGRESS_VALUE;
        }
      }
    });
    // get slot info first time.
    this.getSlotInfo();
  }

  /**
   * destroy object.
   */
  ngOnDestroy() {
    console.log("Close sign progress usb token")
    this.closePopup();
  }

  /**
   * click stop sign button.
   */
  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.sign_wait_stop_confirm'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        this.isDisabledStopSignButton = true;
        this.selectedActionClose = SignWaitProgressUsbTokenComponent.STOP_ACTION;

        this.documentService.stopSignWait().subscribe();
      }
    });
  }

  /**
   * close button sign button.
   */
  onClickCloseDialog() {
    this.closePopup();
  }

  /**
   * Load data from data.
   * Format of returned result.
   * {
   *    "info": {
   *      "id": "string",
   *      "createdTime": "DATE",
   *      "cancelTime": "",
   *      "description": "",
   *      "success": false,
   *      "details": [
   *        {
   *          "contractId": "",
   *          "status": 0,
   *          "description": ""
   *        }
   *      ]
   *    },
   *    "contracts": "json string array of contracts"
   * }
   */
  private getSlotInfo() {
    this.documentService.getWaitSlotStatus(true, this.isFinished);
  }

  /**
   * close popup.
   */
  private closePopup() {
    if (this.selectedActionClose === SignWaitProgressUsbTokenComponent.CLOSE_ACTION) {
      if (this.processedPercent === SignWaitProgressUsbTokenComponent.FINISH_PROGRESS_VALUE) {
        this.selectedActionClose = SignWaitProgressUsbTokenComponent.FINISH_ACTION;
      }
    }

    this.actions.next(this.selectedActionClose);
  }

}
